import moment, { Moment, unitOfTime } from 'moment';
import { ISO_DATE_FORMAT } from 'utils';
import {
	IRoundFrequency,
	ISurveyDurationTypes,
	RoundFrequencyValues,
	SurveyDurationValues,
} from '../models';

export function getRoundCount(
	surveyStartDate: Moment,
	surveyDuration: ISurveyDurationTypes,
	roundFrequency: IRoundFrequency,
) {
	const surveyEndDate = SurveyDurationValues[surveyDuration](
		surveyStartDate.format(ISO_DATE_FORMAT),
	);

	return (
		Math.floor(
			surveyEndDate.diff(
				moment(surveyStartDate),
				RoundFrequencyValues[roundFrequency].value as unitOfTime.Base,
			) / RoundFrequencyValues[roundFrequency].count,
		) || 1
	);
}
